import SettingsNavigation from '@portal/containers/settings/SettingsNavigation';
import './Settings.less';
import { Outlet } from 'react-router-dom';
import { EamcChatbotGate } from '@/eamcChatbot/EamcChatbotGate';

const SettingsLayout = () => {
  return (
    <>
      <div className={'settings-nav-bar'}>
        <SettingsNavigation />
      </div>
      <Outlet />
      {/* EAMC Chatbot — fixed-position side-dock, settings routes only */}
      <EamcChatbotGate />
    </>
  );
};

export default SettingsLayout;
